import { Show } from 'solid-js';
import IconLeftArrow from '~/assets/icons/leftArrow.svg';
import { CLOSE } from '~/assets/strings';
import { useLocalization } from '~/hooks/useLocalization';
import { useMenu } from './MenuContext';

export const MenuTrigger = () => {
  const { t } = useLocalization();
  const { pageTitle, collapsed, toggleCollapsed, isShowBackButton } = useMenu();

  const handleGoBack = () => {
    window.history.go(-1);
  };

  return (
    <Show
      when={isShowBackButton()}
      fallback={
        <button
          class="flex items-center gap-3 p-2 font-semibold uppercase text-secondary-color outline-0 transition focus-within:ring aria-expanded:font-normal aria-expanded:text-[var(--primary-color)] md:hidden"
          aria-label="toggle menus"
          aria-expanded={!collapsed()}
          onClick={toggleCollapsed}>
          <span class="hamburger">
            <i />
            <i />
            <i />
          </span>
          {collapsed() ? t(pageTitle()) : t(CLOSE)}
        </button>
      }>
      <div class="flex items-center gap-1.5 p-2">
        <button onClick={handleGoBack}>
          <img src={IconLeftArrow} />
        </button>
        <span class="font-semibold text-text-level01">{t(pageTitle())}</span>
      </div>
    </Show>
  );
};
